// extracted by mini-css-extract-plugin
export default {"linkContainer":"mEolnup9jPIafkgXxVqt","linkIcon":"y9TWyWbcrWhAMmDZ03vQ"};